var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10948_183628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10948_183628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49967 26.6651C7.76634 26.6651 7.13856 26.404 6.61634 25.8818C6.09412 25.3595 5.83301 24.7318 5.83301 23.9984V21.3318C5.83301 20.954 5.96079 20.6373 6.21634 20.3818C6.4719 20.1262 6.78856 19.9984 7.16634 19.9984C7.54412 19.9984 7.86079 20.1262 8.11634 20.3818C8.3719 20.6373 8.49967 20.954 8.49967 21.3318V23.9984H24.4997V21.3318C24.4997 20.954 24.6275 20.6373 24.883 20.3818C25.1386 20.1262 25.4552 19.9984 25.833 19.9984C26.2108 19.9984 26.5275 20.1262 26.783 20.3818C27.0386 20.6373 27.1663 20.954 27.1663 21.3318V23.9984C27.1663 24.7318 26.9052 25.3595 26.383 25.8818C25.8608 26.404 25.233 26.6651 24.4997 26.6651H8.49967ZM15.1663 10.4651L12.6663 12.9651C12.3997 13.2318 12.083 13.3595 11.7163 13.3484C11.3497 13.3373 11.033 13.1984 10.7663 12.9318C10.5219 12.6651 10.3941 12.354 10.383 11.9984C10.3719 11.6429 10.4997 11.3318 10.7663 11.0651L15.5663 6.2651C15.6997 6.13177 15.8441 6.03733 15.9997 5.98177C16.1552 5.92622 16.3219 5.89844 16.4997 5.89844C16.6775 5.89844 16.8441 5.92622 16.9997 5.98177C17.1552 6.03733 17.2997 6.13177 17.433 6.2651L22.233 11.0651C22.4997 11.3318 22.6275 11.6429 22.6163 11.9984C22.6052 12.354 22.4775 12.6651 22.233 12.9318C21.9663 13.1984 21.6497 13.3373 21.283 13.3484C20.9163 13.3595 20.5997 13.2318 20.333 12.9651L17.833 10.4651V19.9984C17.833 20.3762 17.7052 20.6929 17.4497 20.9484C17.1941 21.204 16.8775 21.3318 16.4997 21.3318C16.1219 21.3318 15.8052 21.204 15.5497 20.9484C15.2941 20.6929 15.1663 20.3762 15.1663 19.9984V10.4651Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrUpload);
export default __webpack_public_path__ + "static/media/ocr-upload.b72b50a6c2db9e8ea98346e286f2e02d.svg";
export { ForwardRef as ReactComponent };